// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___208fF","optionContainer":"styles__optionContainer___1fjfj","title":"styles__title___-WATR","button":"styles__button___yXX4-","name":"styles__name___iFUHN"};


//////////////////
// WEBPACK FOOTER
// ./src/views/today-items/calendar-modal/styles.css
// module id = 1061
// module chunks = 0